/*eslint-disable*/
import '../App.css';
import '../Section.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import { useState, useEffect } from 'react';
import 'animate.css';

function Section2() {

  let [skinNum, setSkinNum] = useState(1);
  let [skinNum2, setSkinNum2] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSkinNum(prevSkinNum => (prevSkinNum % 3) + 1);

      $("#skinF").css({ transition: "clip-path 0.5s", clipPath: "polygon(0 0, 100% 0, 100% 100%, 50% 100%, 0 50%)" })
      $("#skinB").css({ transition: "clip-path 0.5s", clipPath: "polygon(0 50%, 50% 100%, 50% 100%, 0 100%, 0 50%)" })
      setTimeout(() => {
        $("#skinF").css({ clipPath: "polygon(50% 0, 100% 0, 100% 50%, 100% 100%, 0 0)" })
      }, 150)
      setTimeout(() => {
        $("#skinF").css({ clipPath: "polygon(50% 0, 100% 0, 100% 50%, 100% 50%, 50% 0)" })
      }, 300)
      setTimeout(() => {
        $("#skinF").css({ clipPath: "polygon(50% 0, 100% 0, 100% 50%, 100% 50%, 50% 0)" })
      }, 450)

      setTimeout(() => {
        $("#skinB").css({ clipPath: "polygon(0 0, 100% 100%, 50% 100%, 0 100%, 0 50%))" })
      }, 80)
      setTimeout(() => {
        $("#skinB").css({ clipPath: "polygon(50% 0, 100% 50%, 100% 100%, 0 100%, 0 0)" })
      }, 160)
      setTimeout(() => {
        $("#skinB").css({ clipPath: "polygon(100% 0, 100% 0, 100% 100%, 0 100%, 0 0)" })
      }, 270)

      setTimeout(() => {
        setSkinNum2(prevSkinNum2 => (prevSkinNum2 % 3) + 1)
      }, 750)

      setTimeout(() => {
        // 초기화
        $("#skinF").css({ transition: "clip-path 0s", clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 100%)" })
        $("#skinB").css({ transition: "clip-path 0s", clipPath: "polygon(0 100%, 0 100%, 0 100%, 0 100%, 0 100%)" })
      }, 1000)

    }, 2000);
  }, []);

  return (
    <div className='section section2'>
      <p className='title' style={{ left: "-70px", top: "30%", color: "#fff" }}>-&nbsp;챔피언 스킨&nbsp;-</p>
      <div className='section_box'>
        <h3 className='animate__animated animate__fadeInDown'>개성있는</h3>
        <h2 className='animate__animated animate__fadeInDown'>챔피언</h2>
        <p className='animate__animated animate__fadeIn' style={{ animationDelay: '0.4s' }}>스킨으로 좋아하는 챔피언의 외형을 변경해보세요</p>
        <a className='play_box_long animate__animated animate__fadeIn' style={{ width: "170px", animationDelay: '0.4s' }} href=''>지금 플레이하기</a>
      </div>

      <img id='setction2Bg' src={`${process.env.PUBLIC_URL}/canyonbg2.png`} alt="Canyon Background" />
      {/* 뒤에 있는 이미지 */}
      <div id='skinB' className='cp_skin' style={{ left: "50%", clipPath: "polygon(0 100%, 0 100%, 0 100%, 0 100%, 0 100%)", overflow: "hidden" }}>
        <img style={{ width: "700px" }} src={`${process.env.PUBLIC_URL}/akali${skinNum}.png`} alt="챔피언 스킨"></img>
      </div>
      {/* 앞에 있는 이미지 */}
      <div id='skinF' className='cp_skin' style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 100%)", overflow: "hidden" }}>
        <img style={{ width: "700px" }} src={`${process.env.PUBLIC_URL}/akali${skinNum2}.png`} alt="챔피언 스킨"></img>
      </div>
    </div>
  )
}

export default Section2